

export class NewsArticle {
    _id: string;
    Title: string;
    Article: string;
}
